<!-- Loading Spinner -->
<app-loading-spinner></app-loading-spinner>

<div class="access-denied-container">
  <div class="access-denied-card">
    <!-- Header Section -->
    <div class="header-section">
      <div class="icon-container">
        <fa-icon [icon]="faShieldAlt" class="shield-icon"></fa-icon>
        <fa-icon [icon]="faExclamationTriangle" class="warning-icon"></fa-icon>
      </div>
      <h1 class="title">Access Denied</h1>
      <p class="subtitle">You don't have permission to access this resource</p>
    </div>

    <!-- User Details Section -->
    @if (isLoggedIn) {
      <div class="user-details-section">
        <h3 class="section-title">
          <fa-icon [icon]="faUser" class="section-icon"></fa-icon>
          Your Account Details
        </h3>
        <div class="user-info">
          <div class="info-item">
            <fa-icon [icon]="faUser" class="info-icon"></fa-icon>
            <div class="info-content">
              <label>Name:</label>
              <span>{{ userName || 'Not Available' }}</span>
            </div>
          </div>
          <div class="info-item">
            <fa-icon [icon]="faEnvelope" class="info-icon"></fa-icon>
            <div class="info-content">
              <label>Email:</label>
              <span>{{ userEmail || 'Not Available' }}</span>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Message Section -->
    <div class="message-section">
      <h3 class="section-title">What does this mean?</h3>
      <div class="message-content">
        <p>Your account doesn't have the necessary permissions to access this feature. This could be because:</p>
        <ul>
          <li>You don't have editing privileges for this application</li>
          <li>Your account is not in the authorized users list</li>
          <li>Your access level doesn't include administrative functions</li>
        </ul>
        <p class="help-text">
          If you believe you should have access, please contact support with your account details.
        </p>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <button 
        type="button" 
        class="btn btn-primary btn-action" 
        (click)="goBack()"
        title="Go back to previous page">
        <fa-icon [icon]="faArrowLeft" class="btn-icon"></fa-icon>
        Go Back
      </button>
      
      <button 
        type="button" 
        class="btn btn-secondary btn-action" 
        (click)="goHome()"
        title="Go to home page">
        <fa-icon [icon]="faHome" class="btn-icon"></fa-icon>
        Home
      </button>
      
      <button 
        type="button" 
        class="btn btn-danger btn-action" 
        (click)="logout()"
        title="Logout and go to home page">
        <fa-icon [icon]="faSignOutAlt" class="btn-icon"></fa-icon>
        Logout
      </button>
    </div>

    <!-- Footer -->
    <div class="footer-section">
      <p class="footer-text">
        Need help? Contact our support team at 
        <a href="mailto:support@foneticenglish.com" class="support-link">support@foneticenglish.com</a>
      </p>
    </div>
  </div>
</div>